import { EventEmitter, Injector, Output, Directive } from '@angular/core';

import * as moment from 'moment';

import {AnswerType, Question} from '../../model/model';
import { NavService } from 'shared/nav/nav.service';
import { DefaultPage } from 'app/menu/components/default-page/default-page';

const LABEL_FORMAT: string = 'DD.MM.YYYY';
const LABEL_FORMAT_SHORT: string = 'D.M.';

@Directive()
export abstract class QuestionPage extends DefaultPage {

  protected question: Question;
  public title: string;
  public description: string;
  public questionDate: Date;
  public currentQuestionDate: Date;
  public canSkipAll: boolean = false;
  public skipButtonsVisible: boolean = false;
  public asGoal: boolean = false;

  @Output() public answerSelected: EventEmitter<AnswerType> = new EventEmitter<AnswerType>();
  @Output() public questionSkipped: EventEmitter<Question> = new EventEmitter<Question>();
  @Output() public allQuestionsSkipped: EventEmitter<Question> = new EventEmitter<Question>();
  @Output() public answerAsGoal: EventEmitter<AnswerType> = new EventEmitter<AnswerType>();

  constructor(injector: Injector, navService: NavService) {
    super(navService);
    this.question = injector.get('question');
    this.title = injector.get('title');
    this.description = injector.get('description');
    this.questionDate = injector.get('questionDate');
    this.currentQuestionDate = injector.get('currentQuestionDate');
    this.skipButtonsVisible = injector.get('skipButtonsVisible');
    this.asGoal = injector.get('asGoal');
    this._setCanSkipAll();
  }

  private _setCanSkipAll(): void {
    if (!this.currentQuestionDate || !this.questionDate) {
      this.canSkipAll = false;
      return;
    }

    if (this.currentQuestionDate == this.questionDate) {
      this.canSkipAll = false;
      return;
    }

    const questionDate: moment.Moment = moment(this.questionDate).startOf('day');
    const currentQuestionDate: moment.Moment = moment(this.currentQuestionDate).startOf('day');
    this.canSkipAll = questionDate.isBefore(currentQuestionDate);
  }

  public onSkipClick(): void {
    this.questionSkipped.emit(this.question);
  }

  public onSkipAllClick(): void {
    this.allQuestionsSkipped.emit(this.question);
  }

  private getLocalizedDate(time: string): string {
    return moment(time).format(LABEL_FORMAT);
  }

  public getDateShort(time: Date): string {
    if (time === null) {
      return '';
    }
    return moment(time).format(LABEL_FORMAT_SHORT);
  }
}
